/**
 * TODO:
 *    1. 大促标签增加 DONE 还需要确认大小，目前小程序的宽高明显计算有问题
 */
import { createBusinessComponent } from '../utils/create';
import TjSwipe from '../swipe';
import TjbUserAvatar from '../user-avatar';
import envHelper from '../utils/envHelper.js';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm.unit ? _c('a', {
      class: _vm.b(),
      style: _vm.layoutStyleCpd,
      attrs: {
        "src": _vm.navUrlCpd
      },
      on: {
        "click": _vm.unitClick
      }
    }, [_c('div', {
      class: _vm.b('picture'),
      style: _vm.imgLayoutStyleCpd
    }, [_vm.isMounted && _vm.isSwipe && _vm.unit.pictureList && _vm.unit.pictureList.length > 0 ? _c('div', {
      class: _vm.b('picture__swipe')
    }, [_c('tj-swipe', {
      class: _vm.b('picture__swipe__com'),
      attrs: {
        "show-indicators": false
      }
    }, _vm._l(_vm.unit.pictureList, function (image, index) {
      return _c('tj-swipe-item', {
        key: index
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: image,
          expression: "image"
        }],
        staticClass: "tjf-img-background",
        class: _vm.b('picture__img')
      })]);
    }))], 1) : _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.unit.defaultPicture,
        expression: "unit.defaultPicture"
      }],
      staticClass: "tjf-img-background",
      class: _vm.b('picture__img')
    }), _c('div', {
      class: _vm.b('picture__info')
    }, [_vm.isShowPromotion ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.unit.promotionPicUrl,
        expression: "unit.promotionPicUrl"
      }],
      class: _vm.b('picture__info__promotion')
    }) : _vm._e(), _vm.isShowQualityCertification ? _c('span', {
      class: _vm.b('picture__info__quality-certification')
    }, [_vm._v(_vm._s(_vm.unit.qualityCertification))]) : _vm._e()]), _vm.isShowFavorite ? _c('span', {
      class: _vm.b('picture__favorite', _vm.unit.isFavorite ? 'favorite' : 'unfavorite'),
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.favoriteClick($event);
        }
      }
    }) : _vm._e(), _vm._t("picture-full"), _vm.unit.failType ? _c('div', {
      class: _vm.b('picture__booking', 'unbooking-' + _vm.unit.failType)
    }) : _vm._e()], 2), _c('div', {
      class: _vm.b('info')
    }, [_vm.isShowAvatar ? _c('tjb-user-avatar', {
      class: _vm.b('info__avatar'),
      attrs: {
        "photo-url": _vm.unit.logoUrl,
        "width": 50,
        "height": 50,
        "border-width": 2,
        "best": _vm.unit.great,
        "rba": _vm.unit.rba
      }
    }) : _vm._e(), _vm.isShowTags && _vm.unit.tags && _vm.unit.tags.length > 0 ? _c('div', {
      class: _vm.b('info__unit-tag', _vm.isShowAvatar ? 'avatar' : '')
    }, [_c('div', {
      class: _vm.b('info__unit-tag__layout')
    }, _vm._l(_vm.unit.tags, function (tag) {
      return _c('span', {
        key: tag,
        staticClass: "tj-hairline--surround",
        class: _vm.b('info__unit-tag__item')
      }, [_vm._v(_vm._s(tag))]);
    })), _c('span', {
      class: _vm.b('info__unit-tag__overlay')
    })]) : _vm._e(), _c('div', {
      staticClass: "tj-ellipsis",
      class: _vm.b('info__title')
    }, [_c('i', {
      class: _vm.b('info__title__quick')
    }), _c('span', [_vm._v(_vm._s(_vm.unit.unitName))])]), _vm._t("desc-price-right"), _vm.unit.unitSummeries && _vm.unit.unitSummeries.length ? _c('div', {
      staticClass: "tj-ellipsis",
      class: _vm.b('info__desc')
    }, _vm._l(_vm.unit.unitSummeries, function (item, index) {
      return _c('span', {
        key: index,
        class: _vm.b('info__desc__text', {
          split: true
        })
      }, [_vm._v(_vm._s(item.text)), index !== _vm.unit.unitSummeries.length - 1 ? _c('i', {
        class: _vm.b('info__desc__split')
      }) : _vm._e()]);
    })) : _vm._e(), _vm._t("price-right"), _c('div', {
      staticClass: "tj-ellipsis",
      class: _vm.b('info__price')
    }, [!_vm.unit.priceMissingText ? [_c('span', {
      class: _vm.b('info__price__final')
    }, [_vm._v("￥" + _vm._s(_vm.unit.finalPrice))]), _vm.unit.finalPrice !== _vm.unit.productPrice ? _c('span', {
      class: _vm.b('info__price__product')
    }, [_vm._v("￥" + _vm._s(_vm.unit.productPrice))]) : _vm._e()] : [_c('span', {
      class: _vm.b('info__price__final', 'missing-text')
    }, [_vm._v(_vm._s(_vm.unit.priceMissingText))])], _c('span', {
      class: _vm.b('info__price__tag')
    }, _vm._l(_vm.unit.priceTags && _vm.unit.priceTags, function (tag, index) {
      return _c('span', {
        key: index,
        class: _vm.b('info__price__tag__item'),
        style: _vm._f("tagStyleFilter")(tag)
      }, [_vm._v(_vm._s(tag.text))]);
    }))], 2)], 2), _vm.unit.failType ? _c('div', {
      class: _vm.b('overlay')
    }) : _vm._e()]) : _vm._e();
  },
  name: 'unit-item',
  props: {
    /**
     * 房屋数据，强制格式
     * @type {Object}
     */
    unit: {
      type: Object
    },

    /**
     * 房屋跳转地址,无地址自动跳转默认地址
     * @type {String}
     */
    unitUrl: {
      type: String
    },

    /**
     * 是否开启点击功能，禁用自动跳转
     * @type {Boolean}
     */
    isEnableClick: {
      type: Boolean,
      default: false
    },

    /**
     * 是否开启多张图片
     * @type {Boolean}
     */
    isSwipe: {
      type: Boolean,
      default: false
    },

    /**
     * 是否显示收藏
     * @type {Boolean}
     */
    isShowFavorite: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示头像
     * @type {Boolean}
     */
    isShowAvatar: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示标签配置
     * @type {Boolean}
     */
    isShowTags: {
      type: Boolean,
      default: false
    },

    /**
     * 是否显示促销信息
     * @type {Boolean}
     */
    isShowPromotion: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示品质认证信息
     * @type {Boolean}
     */
    isShowQualityCertification: {
      type: Boolean,
      default: true
    },

    /**
     * 边框Radius
     * @type {String}
     */
    borderRadius: {
      type: String,
      default: '8px'
    },

    /**
     * 背景色
     * @type {String}
     */
    background: {
      type: String,
      default: '#fff'
    },

    /**
     * 内间距
     * @type {String}
     */
    padding: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      // 是否mounted状态
      isMounted: false
    };
  },
  computed: {
    /**
     * 计算属性: 房屋卡片layout的样式style
     * @returns {Object} style object
     */
    layoutStyleCpd: function layoutStyleCpd() {
      return {
        padding: this.padding,
        background: this.background
      };
    },

    /**
     * 计算属性: 图片样式Style
     * @returns {Object} style object
     */
    imgLayoutStyleCpd: function imgLayoutStyleCpd() {
      return {
        borderRadius: this.borderRadius
      };
    },

    /**
     * 计算属性: 房屋卡片跳转Url
     * @returns {String}
     */
    navUrlCpd: function navUrlCpd() {
      var url = '';

      if (this.unitUrl) {
        url = this.unitUrl;
      } else {
        if (this.isMounted) {
          // 根据环境获取当前的URL
          var env = envHelper.getTujiaEnv();

          if (env && env.indexOf('.') === -1) {
            env = '.' + env;
          }

          var protocol = 'http' + (env === 'dev' ? '' : 's');
          url = protocol + "://m" + env + ".tujia.com/detail/" + this.unit.unitId + '.htm';
          console.log('url...' + url);
        } else {
          url = 'https://m.tujia.com/detail/' + this.unit.unitId + '.htm';
        }
      }

      return url;
    } // 后续增加打点恢复代码
    // indicatorCountCpd() {
    //   if (!this.unit || !this.unit.pictureList || this.unit.pictureList.length === 0) return 0;
    //   return this.unit.pictureList.length > 7 ? 7 : this.unit.pictureList.length;
    // }

  },
  mounted: function mounted() {
    this.isMounted = true;
  },
  methods: {
    /**
     * 收藏点击事件
     */
    favoriteClick: function favoriteClick() {
      // 未有前置数据前特殊处理
      if (this.unit.isFavorite === undefined || this.unit.isFavorite === null) {
        this.$set(this.unit, 'isFavorite', false);
      }

      this.$emit('favoriteClick', this.unit);
    },

    /**
     * 房屋卡片点击事件
     */
    unitClick: function unitClick() {
      if (this.isEnableClick) {
        this.$emit('click', this.unit);
      } else {
        // 如果是m站点，自动使用router
        if (/^m([1-9]?.fvt)?.tujia.com/.test(window.location.href)) {
          this.router.push('/detail/' + this.unit.unitId + '.htm');
        } else {
          window.location.href = this.navUrlCpd;
        }
      }
    } // 后续增加打点恢复
    // indicatorAutoBem(bemClassName, positionIndex, activeIndex) {
    //   positionIndex = positionIndex - 1;
    //   let stateName = '';
    //   if (Math.abs(activeIndex - positionIndex) >= 2 && (positionIndex === 0 || positionIndex === this.indicatorCountCpd - 1)) {
    //     stateName = 'small';
    //   }
    //   if (activeIndex === positionIndex || (positionIndex === this.indicatorCountCpd - 1 && activeIndex >= this.indicatorCountCpd - 1)) {
    //     stateName = 'active';
    //   }
    //   return this.b(bemClassName, stateName);
    // },

  },
  filters: {
    /**
     * 过滤器: tag style
     * @param {Object} tag tag对象
     * @returns {Object} style
     */
    tagStyleFilter: function tagStyleFilter(tag) {
      if (!tag) return null;
      return {
        color: tag.color,
        backgroundColor: tag.background && tag.background.color
      };
    }
  },
  component: {
    TjSwipe: TjSwipe,
    TjbUserAvatar: TjbUserAvatar
  }
});